
import { CustomLoading } from 'common'
import { Alert } from '@mui/material'


export const ReportViewer = ({ useFetchInit }) =>{

    const {
        FetchData
    } = useFetchInit

    const { fetchTransactionsReport } = FetchData
    const { dataPdfTransactionsReport, loadingFetchAllTransactionsReport } = fetchTransactionsReport

    return(
        <>
            {(loadingFetchAllTransactionsReport)&&(<CustomLoading/>)}
            {(!loadingFetchAllTransactionsReport && typeof dataPdfTransactionsReport === 'string' && dataPdfTransactionsReport !== '')&&(
                <iframe
                    src={dataPdfTransactionsReport}
                    width="100%"
                    height="700"
                    style={{ border: "none" }}
                    title="Reporte de movimientos de caja"
                />
            )}
            {(!loadingFetchAllTransactionsReport && dataPdfTransactionsReport && typeof dataPdfTransactionsReport === 'object')&&(
                <Alert severity="warning">
                    {dataPdfTransactionsReport.message}
                </Alert>
            )}
        </>
    )
}